import NewAppFooter from "./NewAppFooter"
import NewAppHeader from "./NewAppHeader"
import { Outlet } from "react-router-dom";
import { useApi } from "../../services/axiosInterceptor";

const StudentLayout = () => {
    useApi();
    return (
        <div>
            <NewAppHeader />
            <div style={{ minHeight: '80vh', padding: '20px' }}>
                <Outlet />
            </div>
            <NewAppFooter />
        </div>
    )
}

export default StudentLayout;